import React, { FunctionComponent, useCallback, useEffect } from 'react';

import { NewTab } from '@yandex-360/iconostasis/dist/icons/NewTab';
import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { ListItem } from '@yandex-360/orb-components/dist/components/ListItem/bundle';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { useSelector } from 'react-redux';

import { getExternalLinks } from '../../../../../../helpers/external-links';
import { i18n } from '../../../../../../helpers/i18n';
import { useActions } from '../../../../../../hooks';
import {
    getFeedbackFormVisibility,
    setFeedbackFormVisibility as setFeedbackFormVisibilityAction,
} from '../../../../../settings';
import { Island } from '../../island';
import { FeedbackForm } from './feedback-form';
import css from './styles.css';

export const HelpSection: FunctionComponent = () => {
    const { help: helpLink } = useSelector(getExternalLinks);
    const isFeedbackFormVisible = useSelector(getFeedbackFormVisibility);

    const { setFeedbackFormVisibility } = useActions({ setFeedbackFormVisibility: setFeedbackFormVisibilityAction });

    const showFeedbackForm = useCallback(() => {
        setFeedbackFormVisibility(true);
    }, [setFeedbackFormVisibility]);

    useEffect(
        () => () => {
            setFeedbackFormVisibility(false);
        },
        [setFeedbackFormVisibility]
    );

    return (
        <Island className={css.helpWrapper}>
            <div className={css.controls}>
                <Text as="h3" className={css.header} typography="heading-xs">
                    {i18n('settings-v2', 'section-help-title')}
                </Text>
                <ListItem
                    interaction={false}
                    className={css.row}
                    label={i18n('settings-v2', 'support-help-title')}
                    endSlot={
                        <Button
                            elementType="a"
                            view="neutral"
                            href={helpLink}
                            target="_blank"
                            size="md"
                            iconLeft={<NewTab size="sm" />}
                            testId="support-help-button"
                        >
                            {i18n('settings-v2', 'support-help-go-to')}
                        </Button>
                    }
                />
                <ListItem
                    className={css.row}
                    label={i18n('settings-v2', 'support-title')}
                    interaction={false}
                    endSlot={
                        <Button
                            view="neutral"
                            size="md"
                            isDisabled={isFeedbackFormVisible}
                            onPress={showFeedbackForm}
                            testId="support-report-button"
                        >
                            {i18n('settings-v2', 'support-report-problem')}
                        </Button>
                    }
                />
            </div>
            {isFeedbackFormVisible && <FeedbackForm />}
        </Island>
    );
};
